/**
 * share button
 *
 * This component handles the share behaviour -> on mobile: native sharing, on desktop: dropdown sharing
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.data('share', (config) => ({
        showButton: false,
        title: config.title ?? '',
        dropdownOpen: false,
        shareButton: {
            ['@click']() {
                if (navigator.share && window.innerWidth < 1024) {
                    navigator.share({
                        text: this.title,
                        url: window.location.href,
                    }).catch((error) => {
                        if (error.name !== 'AbortError') {
                            console.error('Sharing failed:', error)
                        }
                    });
                } else {
                    this.dropdownOpen = !this.dropdownOpen;
                }
            },
            ['@click.outside']() {
                this.dropdownOpen = false;
            }

        },
        copyLink: {
            ['@click']() {
                navigator.clipboard.writeText(window.location.href);
            }
        },
        init() {
        },
    }));
});
